
import { ChevronDown } from "lucide-react";
import React from "react";
import { MobileTooltipWrapper } from "@/components/ui/tooltip";
import { useCollapsible } from "../../collapsible-context/CollapsibleContext";

interface CollapsibleIconProps {
  iconSize: number;
}

const CollapsibleIcon = ({ iconSize }: CollapsibleIconProps) => {
  // Access the collapsible context
  const { isOpen, toggleOpen } = useCollapsible();
  
  return (
    <MobileTooltipWrapper content={isOpen ? "Hide details" : "Show details"}>
      <div 
        className="flex-shrink-0 cursor-pointer" 
        onClick={(e) => {
          e.stopPropagation();
          toggleOpen();
        }}
        aria-label={isOpen ? "Hide details" : "Show details"}
      >
        <ChevronDown 
          size={iconSize} 
          className={`text-muted-foreground transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} 
        />
      </div>
    </MobileTooltipWrapper>
  );
};

export default CollapsibleIcon;
